import html2canvas from "html2canvas";

/**
 * A few JavaScript Functions for Images and Files
 *  */

export function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

// Convert a Base64-encoded string to a File object
export function base64StringtoFile(base64String, filename) {
  var arr = base64String.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

// Download a Base64-encoded file
export function downloadBase64File(base64Data, filename) {
  var element = document.createElement("a");
  element.setAttribute("href", base64Data);
  element.setAttribute("download", filename);
  element.style.display = "none";
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
}

// Extract an Base64 Image's File Extension
export function extractImageFileExtensionFromBase64(base64Data) {
  return base64Data.substring(
    "data:image/".length,
    base64Data.indexOf(";base64")
  );
}

// Base64 Image to Canvas with a Crop
export function image64toCanvasRef(canvas, image64, pixelCrop) {
  canvas.width = pixelCrop.width;
  canvas.height = pixelCrop.height;
  const ctx = canvas.getContext("2d");
  const image = new Image();
  image.src = image64;
  image.onload = function() {
    ctx.drawImage(
      image,
      pixelCrop.x,
      pixelCrop.y,
      pixelCrop.width,
      pixelCrop.height,
      0,
      0,
      pixelCrop.width,
      pixelCrop.height
    );
  };
  // return canvas;
}

// Get Image Info: width, height and image type ...
export function getImageInfo(img) {
  return new Promise(resolve => {
    let image = new Image();
    let info = {};
    image.src = img.url;
    image.onload = function() {
      info = {
        width: this.width,
        height: this.height,
        type: this.src.split(";")[0].split("/")[1]
      };
      resolve(info);
    };
  });
}

export function isValidSize(type, width, height) {
  if (type.name === "logo") {
    if (type.shape === "square") {
      if (width < 128 || height < 128) return false;
    } else if (type.shape === "landscape") {
      if (width < 512 || height < 128) return false;
    }
  } else if (type.name === "image") {
    if (type.shape === "square") {
      if (width < 300 || height < 300) return false;
    } else if (type.shape === "landscape") {
      if (width < 600 || height < 314) return false;
    }
  }
  return true;
}

export function download(parentId, adElement, imageElement, logoElement) {
  const parentElement = document.getElementById(parentId);
  return new Promise((resolve, reject) => {
    html2canvas(parentElement.querySelector(`#${adElement.id}`), {
      scale: 1,
      profile: true,
      useCORS: true,
      allowTaint: true,
      letterRendering: true,
      onrendered: function(canvas) {
        var ctx = canvas.getContext("2d");
        ctx.webkitImageSmoothingEnabled = false;
        ctx.mozImageSmoothingEnabled = false;
        ctx.imageSmoothingEnabled = false;
      },
      onclone: function(document) {
        const adContainer = document
          .getElementById(parentId)
          .querySelector(`#${adElement.id}`);
        if (adContainer.querySelector("section")) {
          if (adElement.backgroundColor) {
            adContainer.querySelector("section").style.backgroundColor =
              adElement.backgroundColor;
          }
          adContainer.querySelector("section").style.width = adElement.width;
          adContainer.querySelector("section").style.marginLeft =
            adElement.sectionMarginLeft || "0px";
        }
        adContainer.style.marginTop = adElement.marginTop;
        adContainer.style.marginLeft = adElement.marginLeft;
        if (imageElement) {
          const image = adContainer.querySelector(imageElement.className);
          image.style.width = imageElement.width;
          image.style.marginTop = imageElement.marginTop;
          image.style.marginLeft = imageElement.marginLeft;
        }
        if (logoElement) {
          const logo = adContainer.querySelector(logoElement.className);
          logo.style.width = logoElement.width;
          logo.style.heigh = logoElement.heigh;
        }
      }
    }).then(canvas => {
      resolve(
        canvas
          .toDataURL("image/jpeg")
          .replace("image/jpeg", "image/octet-stream")
      );
    });
  });
}
